import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {ActionsRow, DetailValue, modal, utils, Loader} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {Button, ButtonToolbar, Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import * as subjektActions from "../actions/subjektActions";
import * as opravneniActions from "../actions/opravneniActions";
import SubjektApi from "../api/gen/cgo/SubjektApi";
import NastaveniObjednavkyUzivatelForm from "../forms/NastaveniObjednavkyUzivatelForm";
import NastaveniObjednavkySpolecnostForm from "../forms/NastaveniObjednavkySpolecnostForm";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Panel zobrazující nastavení objednávky uživatele nebo společnosti (výchozí způsob dopravy a platby).
 */
class NastaveniObjednavkyPanel extends Component<WithTranslation> {

    static propTypes = {
        nastaveniObjednavky: PropTypes.object.isRequired, // UzivatelPredvolbyVO nebo SpolecnostPredvolbyVO
        loggedInUserId: PropTypes.number.isRequired, // ID přihlášeného uživatele, potřebné pro správný invalidate
        uzivatelId: PropTypes.number, // ID uživatele, pokud se nastavení vztahuje k uživateli
        spolecnostId: PropTypes.number, // ID společnosti, pokud se nastavení vztahuje ke společnosti
        readOnly: PropTypes.bool, // zda nezobrazit tlačítko pro úpravy, implicitně true
    };

    static defaultProps = {
        readOnly: true,
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
    };

    handleEditVychoziZpusoby = () => {
        const {loggedInUser, nastaveniObjednavky, uzivatelId, spolecnostId, t} = this.props;

        if (uzivatelId) {
            this.props.dispatch(modal.ModalActions.show(
                NastaveniObjednavkyUzivatelForm,
                {
                    onSubmit: (data) => {
                        return SubjektApi.updateUzivatelPredvolby(data, uzivatelId);
                    },
                    onSubmitSuccess: (result, dispatch) => {
                        dispatch(modal.ModalActions.hide());
                        dispatch(subjektActions.invalidateUzivatelDetail(uzivatelId));
                        if (loggedInUser.data.id === uzivatelId) {
                            dispatch(opravneniActions.invalidateLoggedInUser());
                        }
                    },
                    onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                    initialValues: nastaveniObjednavky,
                    uzivatelId
                },
                t('order.configuration_edit'),
                {size: "md"}
            ));
        } else if (spolecnostId) {
            this.props.dispatch(modal.ModalActions.show(
                NastaveniObjednavkySpolecnostForm,
                {
                    onSubmit: (data) => {
                        return SubjektApi.updateSpolecnostPredvolby(data, spolecnostId);
                    },
                    onSubmitSuccess: (result, dispatch) => {
                        dispatch(modal.ModalActions.hide());
                        dispatch(subjektActions.invalidateSpolecnostDetail(spolecnostId));
                    },
                    onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                    initialValues: nastaveniObjednavky,
                    spolecnostId
                },
                t('order.configuration_edit'),
                {size: "md"}
            ));
        }
    };

    renderActions = () => {
        const {readOnly, vydejniPobockyList, t} = this.props;
        return <ButtonToolbar>
            {!readOnly && <Button onClick={this.handleEditVychoziZpusoby} disabled={vydejniPobockyList.isFetching}>{t('edit')}</Button>}
        </ButtonToolbar>
    };

    render() {
        const {loggedInUser, nastaveniObjednavky, spolecnostId, t} = this.props;

        if (!loggedInUser.fetched) {
            return <Loader/>;
        }

        let content;
        if (spolecnostId) {
            content = <Row>
                <Col xs={4}>
                    <DetailValue textOverflow label={t('order.default_delivery_method')}>{nastaveniObjednavky.zpusobDopravaVychozi ? nastaveniObjednavky.zpusobDopravaVychozi.nazevDoprava : "-"}</DetailValue>
                </Col>
                <Col xs={4}>
                    <DetailValue textOverflow label={t('order.default_payment_method')}>{nastaveniObjednavky.zpusobPlatbaVychozi ? nastaveniObjednavky.zpusobPlatbaVychozi.nazevZpusobPlatba : "-"}</DetailValue>
                </Col>
                <Col xs={4}>
                    <DetailValue textOverflow label={t('order.dispensing_branch')}>{nastaveniObjednavky.pobockaVydej ? nastaveniObjednavky.pobockaVydej.nazevPobocka : "-"}</DetailValue>
                </Col>
                <Col xs={4}>
                    <DetailValue textOverflow label={t('order.skip_contact')}>{nastaveniObjednavky.preskocitKontakt ? t('yes') : t('no')}</DetailValue>
                </Col>
                <Col xs={4}>
                    <DetailValue textOverflow label={t('order.skip_delivery')}>{nastaveniObjednavky.preskocitDoprava ? t('yes') : t('no')}</DetailValue>
                </Col>
                <Col xs={4}>
                    <DetailValue textOverflow label={t('order.skip_payment')}>{nastaveniObjednavky.preskocitPlatba ? t('yes') : t('no')}</DetailValue>
                </Col>
            </Row>
        } else {
            content = <Row>
                <Col xs={6}>
                    <DetailValue textOverflow label={t('order.default_delivery_method')}>{nastaveniObjednavky.zpusobDopravaVychozi ? nastaveniObjednavky.zpusobDopravaVychozi.nazevDoprava : "-"}</DetailValue>
                </Col>
                <Col xs={6}>
                    <DetailValue textOverflow label={t('order.default_payment_method')}>{nastaveniObjednavky.zpusobPlatbaVychozi ? nastaveniObjednavky.zpusobPlatbaVychozi.nazevZpusobPlatba : "-"}</DetailValue>
                </Col>
                <Col xs={6}>
                    <DetailValue textOverflow label={t('notification_email')}>{nastaveniObjednavky.notifikaceEmail ? t('yes') : t('no')}</DetailValue>
                </Col>
                <Col xs={6}>
                    <DetailValue textOverflow label={t('notification_sms')}>{nastaveniObjednavky.notifikaceSms ? t('yes') : t('no')}</DetailValue>
                </Col>
            </Row>
        }

        return <Card className="nastaveni-objednavky-panel">
            <CardHeader>
                <ActionsRow actions={this.renderActions()}>
                    <h2>{t('order.configuration')}</h2>
                </ActionsRow>
            </CardHeader>
            <CardBody>
                {content}
            </CardBody>
        </Card>
    }
}

function mapStateToProps(state) {
    return {
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        vydejniPobockyList: utils.storeFromArea(state, subjektActions.SPOLECNOST_POBOCKY_VYDEJ_VCETNE_VYDEJNI_LIST_AREA)
    }
}

export default connect(mapStateToProps)(withTranslation()(NastaveniObjednavkyPanel));
